import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  Box,
  Stack, 
  TextareaAutosize, 
  TextField,
  Tabs,
  Tab,
  Tooltip,
  DialogActions,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Grid,
} from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import EditNoteIcon from '@mui/icons-material/EditNote';
import FilterListIcon from "@mui/icons-material/FilterList";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Chaser, GetUsers } from "../../Services/api";
import instance from "../../redux/api";
import {
  getAccountsList,
  getBrokerBranchesList,
  getCurrencyList,
} from "../../redux/slice/bankStatmentTransactionsSlice";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
import { CommonButton } from "../common/commonButton";
import { numberFormatter } from "../../utils/generalFunctions";
import { commonToast } from "../common";
import {
  primaryButtonStyle,
  primaryButtonHoverColor,
} from "../common/commonButtonStyles";
import dayjs from 'dayjs';
import { getPaginationCount } from "../CashAllocation/utils";
import "../common/commonPageStyles.css";
// import { ViewAndEditBankTransaction } from "../CashTracker/ViewAndEditTxnDialog";

//styles - removed unused constants

const yellow = {
  height: "15px",
  width: "15px",
  borderRadius: "50%",
  backgroundColor:"rgb(255, 238, 0)",
  textAlign: "center"
}

const green = {
  height: "15px",
  width: "15px",
  borderRadius: "50%",
  backgroundColor:"rgb(1, 105, 13)",
  textAlign: "center"
}

const red = {
  height: "15px",
  width: "15px",
  borderRadius: "50%",
  backgroundColor:"rgb(255, 0, 0)",
  textAlign: "center"
}

const tooltipStyle = {
  backgroundColor: "#fff",
  color: '#3b3b3b',
  fontSize: '10px',
  border: '1px solid #3b3b3b',
  borderRadius: '0px',
  padding: '6px 6px',
  maxWidth: 300,
  whiteSpace: 'pre-line',
}

export default function ChaserContainer() {
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { search } = useLocation();

  const dispatch = useDispatch();
  const location = useLocation();

  const [currentRow, setCurrentRow] = useState("");
  const [txnMode, setTxnMode] = useState("VIEW");
  const [isOpenTxnDialog, setIsOpenTxnDialog] = useState(false);

  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [brokerList, setBrokerList] = useState([]);
  const [users, setUsers] = useState([]);
  //styles
  const classes = useStyles();

  const getBrokerList = async () => {
    const response = await instance.get("documents/get_broker_list/");
    setBrokerList(response?.data?.Broker_Branch_Name);
  }

  useEffect(() => {
    // Fetch users data from an API
    instance
      .get(GetUsers)
      .then((data) => {
        const filteredUsers = data.data.filter(
          (user) => (user.role === "CC Processor" || user.role === "Lead Role") && user.status === "Active"
        );
        setUsers([...new Set(filteredUsers)]);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    Policy_No: "",
    allocated_date: "",
    Bank_Transaction_Id: "",
    Broker_Branch: "",
    Handler_Name: ""
  });

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isStatusDeSelected, setIsStatusDeSelected] = useState(false);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);
  const [dialogCommentsValue, setDialogCommentsValue] = useState(null);
  const [originalComment, setOriginalComment] = useState("");
  const [shouldLoadData, setShouldLoadData] = useState(true);

  const [tabValue, setTabValue] = useState(2);

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  // to clear search list if all filter fields are empty after search has been performed
  useEffect(() => {
    if (isSearchPerformed) {
      if (Object.values(searchFieldsPrams).every(value => !value) && fromDateValue === "" && toDateValue === "") {
        handleClearSearchList();
      }
    }
  }, [fromDateValue, toDateValue]);

  const [isAuditOpen, setIsAuditOpen] = useState(false);
  const handleActionButton = (currentRowData, currentTxnMode) => {
    setCurrentRow(currentRowData);
    setTxnMode(currentTxnMode);
    if (currentTxnMode == 'AUDIT') {
      setIsAuditOpen(true);
    } else { 
      setIsOpenTxnDialog(true);
    }
  };

  const handleCommentsOpenDialog = (currentRowCommentsData, rowId) => {
    setOpenCommentsDialog(true);
    setDialogCommentsValue(currentRowCommentsData || '');
    setOldConcatenatedComment(currentRowCommentsData || '');
    setCurrentRowId(rowId);
    setOriginalComment(currentRowCommentsData || '');
  };

  const handleCloseDialogs = () => {
    setOpenCommentsDialog(false);
    setDialogCommentsValue('');
    setOldConcatenatedComment('');
    setCurrentRowId(null);
    setIsAuditOpen(false);
  };

  const handleDialogInputChange = (e) => {
    const newValue = e.target.value;
    setDialogCommentsValue(newValue);
    const isModified = newValue !== originalComment;
    markRowAsModified(currentRowId, "comments", isModified, newValue);
  };

  const handleSaveComments = () => {
    setOpenCommentsDialog(false);

    // Only process if there's a new comment
    if (dialogCommentsValue) {

      // Mark the row as modified
      markRowAsModified(currentRowId, "comments", true, dialogCommentsValue);
      setOriginalComment(dialogCommentsValue);
    }

    handleCloseDialogs();
  };

  const [allocationType, setAllocationType] = useState("Query");
  const handleTabChange = async (_, newValue) => {
    setTabValue(newValue);
    setShouldLoadData(true);
    let selectedOption = newValue==0 ? "Allocated" : newValue==1 ? "Over Due" : "Query";
    setAllocationType(selectedOption);
    setPageState((old) => ({
      ...old,
      page: 1,
      pageSize: 25,
    }));
  };

  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const [date3, setDate3] = useState("");
  const [escalationDate, setEscalationDate] = useState("");

  const handleDateChange = (type, value, currentRowId) => {
    const formattedDate = value ? value.format('DD-MM-YYYY') : '';
    if (type == "date1") {
      setDate1(formattedDate);
    } else if (type == "date2") {
      setDate2(formattedDate);
    } else if (type == "date3") {
      setDate3(formattedDate);
    } else {
      setEscalationDate(formattedDate);
    }
    markRowAsModified(currentRowId, "date", true, formattedDate);
  }

  // Track which rows have modified fields
  const [modifiedRows, setModifiedRows] = useState({});
  const [currentRowId, setCurrentRowId] = useState(null);
  const [oldConcatenatedComment, setOldConcatenatedComment] = useState("");

  // Function to get the current display value of a field
  const getDisplayValue = (rowId, fieldType, originalValue) => {
    // If the row has been modified and this field has been changed, return the modified value
    if (modifiedRows[rowId] && modifiedRows[rowId][fieldType] && modifiedRows[rowId][fieldType].modified) {
      return modifiedRows[rowId][fieldType].value;
    }
    // Otherwise return the original value
    return originalValue;
  };

  const { userData } = useSelector((state) => state?.user);
  // Function to check if a specific row has any modified fields
  const isRowModified = (rowId) => {
    return modifiedRows[rowId] !== undefined;
  };

  // Helper function to mark a row as modified and store current values
  const markRowAsModified = (rowId, fieldType, isModified, currentValue = null) => {
    setModifiedRows(prev => {
      // Create a new object to avoid mutation
      const newState = { ...prev };

      // Initialize the row if it doesn't exist
      if (!newState[rowId]) {
        newState[rowId] = {
          comments: { modified: false, value: null },
          date: { modified: false, value: null }
        };
      }

      // Update the specific field
      newState[rowId][fieldType] = {
        modified: isModified,
        value: currentValue
      };

      // If no fields are modified, remove the row
      if (!Object.values(newState[rowId]).some(field => field.modified)) {
        delete newState[rowId];
      }

      return newState;
    });
  };

  const columns = [
    {
      field: "historical",
      headerName: "",
      width: 15,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          { params?.row?.indicator === 'Green' ? (
            <div style={green}></div>
          ) : params?.row?.indicator === 'Yellow' ? (
            <div style={yellow}></div>
          ) : (
            <div style={red}></div>
          )}
        </>
      ),
    },
    {
      field: "handler_name",
      headerName: "Handler Name",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={params?.row?.bank_transaction?.Assigned_User?.user_name}
          componentsProps={{
            tooltip: {
              sx: tooltipStyle,
            },
          }}
          placement="bottom-end"
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [10, -10],
                },
              },
            ],
          }}
        >
          {params?.row?.bank_transaction?.Assigned_User?.user_name}
        </Tooltip>
      )
    },
    {
      field: "Bank_Transaction_Id",
      headerName: "Bank Transaction Id",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={params?.row?.bank_transaction?.Bank_Transaction_Id}
          componentsProps={{
            tooltip: {
              sx: tooltipStyle,
            },
          }}
          placement="bottom-end"
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [10, -10],
                },
              },
            ],
          }}
        >
          {params?.row?.bank_transaction?.Bank_Transaction_Id}
        </Tooltip>
      )
      // renderCell: (params) => (
      //   <a
      //     href={`javascript:void(0)`}
      //     onClick={() =>
      //       handleActionButton(
      //         {
      //           ...params?.row?.bank_txn?.Bank_Transaction_Id,
      //           Real_Bank_Name: params?.row?.bank_txn?.bank_details?.bank_name,
      //         },
      //         "VIEW"
      //       )
      //     }
      //     // target="_blank"
      //     // rel="noopener noreferrer"
      //     style={{ color: "blue", cursor: "pointer" }}
      //   >
      //     {params?.row?.bank_txn?.Bank_Transaction_Id}
      //   </a>
      // ),
    },
    {
      field: "Broker_Branch",
      headerName: "Broker Branch",
      width: 200,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={params?.row?.bank_transaction?.Broker_Branch}
          componentsProps={{
            tooltip: {
              sx: tooltipStyle,
            },
          }}
          placement="bottom-end"
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [10, -10],
                },
              },
            ],
          }}
        >
          {params?.row?.bank_transaction?.Broker_Branch}
        </Tooltip>
      )
    },
    {
      field: "policy_id",
      headerName: "Policy#",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <a
          href={`javascript:void(0)`}
          onClick={() =>
            (window.location.href = `/cash-allocation?txn_id=${encodeURIComponent(params?.row?.bank_transaction?.Bank_Transaction_Id)}&policy_ref=${params?.row?.cash_allocation?.id}`)
          }
          rel="noopener noreferrer"
          role="button"
          style={{ color: "blue" }}
        >
          {params?.row?.cash_allocation?.policy_id}
        </a>
      ),
    },
    {
      field: "allocation_status",
      headerName: "Cash Allocation Status",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => params?.row?.cash_allocation?.allocation_status ?? 0
    },
    {
      field: "receivable_amt",
      headerName: "Premium Due Amount",
      width: 150,
      headerAlign: "center",
      renderCell: (params) => (numberFormatter(params?.row?.cash_allocation?.receivable_amt ?? 0))
    },
    {
      field: "date1_value",
      headerName: "Query Date",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("date1", newValue, params?.row?.id);
            }}
            disabled={params.value || params?.row?.date2_value || params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
            sx={{
              "& .MuiInputBase-root": {
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#d0d0d0",
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottomColor: "#1672DE",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#1672DE",
                },
              },
              // Override calendar colors to blue
              "& .MuiPickersDay-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                  "&:hover": {
                    backgroundColor: "#1565c0 !important",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                },
              },
              "& .MuiPickersCalendarHeader-root": {
                "& .MuiIconButton-root": {
                  color: "#1672DE !important",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                  },
                },
              },
              "& .MuiDayCalendar-weekContainer": {
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                },
              },
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "date2_value",
      headerName: "Chaser 1",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("date2", newValue, params?.row?.id);
            }}
            disabled={!params?.row?.date1_value || params?.row?.date2_value || params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            minDate={dayjs(params?.row?.date1_value)}
            maxDate={dayjs(new Date())}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
            sx={{
              "& .MuiInputBase-root": {
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#d0d0d0",
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottomColor: "#1672DE",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#1672DE",
                },
              },
              // Override calendar colors to blue
              "& .MuiPickersDay-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                  "&:hover": {
                    backgroundColor: "#1565c0 !important",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                },
              },
              "& .MuiPickersCalendarHeader-root": {
                "& .MuiIconButton-root": {
                  color: "#1672DE !important",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                  },
                },
              },
              "& .MuiDayCalendar-weekContainer": {
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                },
              },
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "date3_value",
      headerName: "Chaser 2",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("date3", newValue, params?.row?.id);
            }}
            disabled={!params?.row?.date1_value || !params?.row?.date2_value || params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            minDate={dayjs(params?.row?.date2_value)}
            maxDate={dayjs(new Date())}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
            sx={{
              "& .MuiInputBase-root": {
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#d0d0d0",
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottomColor: "#1672DE",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#1672DE",
                },
              },
              // Override calendar colors to blue
              "& .MuiPickersDay-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                  "&:hover": {
                    backgroundColor: "#1565c0 !important",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                },
              },
              "& .MuiPickersCalendarHeader-root": {
                "& .MuiIconButton-root": {
                  color: "#1672DE !important",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                  },
                },
              },
              "& .MuiDayCalendar-weekContainer": {
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                },
              },
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "escalation_date_value",
      headerName: "Escalation Date",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("escalation_date", newValue, params?.row?.id);
            }}
            disabled={!params?.row?.date1_value || !params?.row?.date2_value || !params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            minDate={dayjs(params?.row?.date3_value)}
            maxDate={dayjs(new Date())}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
            sx={{
              "& .MuiInputBase-root": {
                "& .MuiInput-underline:before": {
                  borderBottomColor: "#d0d0d0",
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottomColor: "#1672DE",
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "#1672DE",
                },
              },
              // Override calendar colors to blue
              "& .MuiPickersDay-root": {
                "&.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                  "&:hover": {
                    backgroundColor: "#1565c0 !important",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                },
              },
              "& .MuiPickersCalendarHeader-root": {
                "& .MuiIconButton-root": {
                  color: "#1672DE !important",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1) !important",
                  },
                },
              },
              "& .MuiDayCalendar-weekContainer": {
                "& .MuiPickersDay-root.Mui-selected": {
                  backgroundColor: "#1672DE !important",
                  color: "white !important",
                },
              },
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "comment",
      headerName: "Comments",
      headerAlign: "center",
      width: 130,
      renderCell: (params) => (
        <>
          {(userData?.role === "CC Processor" || userData?.role === "Manager") ? (
            <div
              onClick={() =>
                handleCommentsOpenDialog(
                  params?.row?.comments,
                  params.row.id
                )
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 5,
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    textWrap: "nowrap",
                  }}
                >
                  {getDisplayValue(
                    params.row.id,
                    "comments",
                    params?.row?.comments?.toLowerCase() === "nan"
                      ? ""
                      : params?.row?.comments
                  )}
                </div>
                <MoreHorizIcon />
              </div>
            </div>
          ) : (
            <div>
              {params?.row?.comments ?? "-"}
            </div>
          )}
        </>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      description: "This column has a value getter and is not sortable.",
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];
        actionsList.push(
          <CommonButton
            text="Save"
            handleClick={() => handleSave(row)}
            disabled={!isRowModified(row.id)}
            sx={primaryButtonStyle}
            hoverColor={primaryButtonHoverColor}
          />
        );
        actionsList.push(
          <GridActionsCellItem
            icon={
              <Tooltip title="Audit Trail">
                {" "}
                <EditNoteIcon />{" "}
              </Tooltip>
            }
            label="audit"
            className="textPrimary"
            onClick={() => handleActionButton(row, "AUDIT")}
            color="inherit"
          />
        );
        return actionsList;
      },
    }
  ];

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  const [historyData, setHistoryData] = useState({})

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}&toggle_value=${allocationType}`;

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      } else {
        // If we get information while performing route navigation
        if (!isClearPerformed) {
          let allocated = location?.state?.allocated || "";
          if (allocated) {
            queryParams = `${queryParams}&allocated=${allocated}`;
          }
          const policyNo = new URLSearchParams(search).get("policyNo");
          if (policyNo) {
            queryParams = `${queryParams}&policyNumber=${policyNo}`;
            setSearchFieldsPrams({
              ...searchFieldsPrams,
              Policy_No: policyNo,
            });
          }
        }
      }

      const response = await instance.get(`${Chaser}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );

        
        setHistoryData(response?.data?.summary)
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleChaserFieldsInputChange = (name, value, reason) => {
    const trimmedValue = typeof value === 'string' ? value?.trim() : value;
    setSearchFieldsPrams({
      ...searchFieldsPrams,
      [name]: trimmedValue,
    });
    setIsStatusDeSelected(false);
    if (reason == "clear") {
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        Bank_Allocation_Status: "",
      });
      setIsStatusDeSelected(true);
    }

    // to clear search list if all filter fields are empty after search has been performed
    if (isSearchPerformed && !trimmedValue) {
      const searchFields = { ...searchFieldsPrams };
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value) && fromDateValue === "" && toDateValue === "") {
        handleClearSearchList();
      }
    }
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchChaserList();
    }
    window.scrollBy({
      top: 335,
      behavior: "smooth",
    });
  };

  const handleFilterDropdown = (name, value, reason, isMulti = false) => {
    if (reason === "clear") {
      setSearchFieldsPrams(prev => ({ ...prev, [name]: isMulti ? [] : "" }));
    } else {
      if (isMulti) {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
      } else {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
      }
    }
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const {
      Policy_No,
      Bank_Transaction_Id,
      Broker_Branch,
      Handler_Name,
    } = searchFieldsPrams;

    if (Policy_No) {
      getSearchQueryParams = `${getSearchQueryParams}&policyNumber=${Policy_No}`;
    }

    if (Bank_Transaction_Id) {
      getSearchQueryParams = `${getSearchQueryParams}&transactionId=${Bank_Transaction_Id}`;
    }

    if (Broker_Branch) {
      getSearchQueryParams = `${getSearchQueryParams}&brokerBranch=${Broker_Branch}`;
    }

    if (Handler_Name) {
      getSearchQueryParams = `${getSearchQueryParams}&handlerName=${Handler_Name}`;
    }

    let formattedFromDateValue = "",
      formattedToDateValue = "";

    if (fromDateValue && toDateValue) {
      formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
      formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
      getSearchQueryParams = `${getSearchQueryParams}&fromAllocationDate=${formattedFromDateValue}&toAllocationDate=${formattedToDateValue}`;
    }

    return getSearchQueryParams;
  };

  const handleSearchChaserList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      let allocated = location?.state?.allocated || "";
      if (allocated) {
        queryParams = `${queryParams}&allocated=${allocated}`;
      }

      if (
        location?.state?.fromDateValue &&
        location?.state?.toDateValue &&
        !queryParams.includes("fromAllocationDate")
      ) {
        let formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "yyyy-MM-dd"
        );
        let formattedToDateValue = format(
          location?.state?.toDateValue,
          "yyyy-MM-dd"
        );
        queryParams = `${queryParams}&fromAllocationDate=${formattedFromDateValue}&toAllocationDate=${formattedToDateValue}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${Chaser}${queryParams}`);
      {
        const data = response.data;
        setHistoryData(data?.summary)
      }
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPaginationCount(0);
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const {
      Policy_No,
      Bank_Transaction_Id,
      Broker_Branch,
      Handler_Name
    } = searchFieldsPrams;
    if (
      Policy_No !== "" ||
      Bank_Transaction_Id !== "" ||
      Broker_Branch !== "" ||
      Handler_Name !== "" ||
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }

    return disabled;
  };

  const handleClearSearchList = async () => {
    setIsClearPerformed(true);
    setIsSearchPerformed(false);
    // clear fields
    setSearchFieldsPrams({
      Policy_No: "",
      Bank_Transaction_Id: "",
      Broker_Branch: "",
      Handler_Name:""
    });
    setFromDateValue("");
    setToDateValue("");
    setShouldLoadData(true);
    // Reset page to 1
    setPageState(old => ({
      ...old,
      page: 1
    }));
  };

  const [isBrokerBranchSelected, setIsBrokerBranchSelected] = useState(false);
  const [isHandlerNameSelected, setIsHandlerNameSelected] = useState(false);

  // Handler for Bank Name Dropdown - kept for backward compatibility but now uses handleFilterDropdown
  const handleBankNameDropdownChange = (name, value, reason) => {
    handleFilterDropdown(name, value, reason);
    if (reason === "clear") {
      setIsBrokerBranchSelected(false);
      setIsHandlerNameSelected(false);
    } else {
      setIsBrokerBranchSelected(true);
      setIsHandlerNameSelected(true);
    }
  };

  const [banksList, setBanksList] = useState([]);

  const getBanksList = async () => {
    const response = await instance.get("documents/get_all_unique_bank_names/");
    setBanksList(response?.data?.bank_names);
  };

  useEffect(() => {
    getBanksList();
  }, []);

  useEffect(() => {
    // Fetch Banks List
    dispatch(getAccountsList());
    // Fetch Broker branches
    dispatch(getBrokerBranchesList());
    // Fetch Currency Details
    dispatch(getCurrencyList());
    // Fetch broker branch
    getBrokerList();

    // load data
    if (shouldLoadData) {
      loadData();
      setShouldLoadData(false);
    }
  }, [allocationType, pageState?.pageSize, pageState?.page, shouldLoadData]);

  const handleSave = async (row) => {
    // Get the current state of all modifiable fields for this row
    const rowModifications = modifiedRows[row.id] || {};
    
    // current date in ISO format for Django
    const currentDate = new Date().toISOString();

    const payload = {};
    if (date1) {
      payload.date1_value = date1;
      payload.date1 = currentDate;
    }
    if (date2) {
      payload.date2_value = date2;
      payload.date2 = currentDate;
    } 
    if (date3) {
      payload.date3_value = date3;
      payload.date3 = currentDate;
    } 
    if (escalationDate) {
      payload.escalation_date_value = escalationDate;
      payload.escalation_date = currentDate;
    }

    try {
      Object.entries(rowModifications).forEach(([field, data]) => {
        if (data.modified) {
          payload[field] = data.value;
        }
      });

      // Add updated_by to payload
      payload.updated_by = userData?.id;

      let response;
      // if (row?.followup_data) {
      //   // If management record exists, use PATCH
      //   payload.id = row?.followup_data?.id;
      //   response = await instance.patch(
      //     `${Chaser}${row?.followup_data?.id}/`,
      //     payload
      //   );
      // } else {
      //   payload.bank_transaction = row?.bank_transaction?.id ?? ""
      //   payload.cash_allocation = row?.id ?? ""
      //   payload.query_status = row?.allocation_status ?? ""
      //   response = await instance.post(Chaser, payload);
      // }


      payload.id = row?.id;
      response = await instance.patch(
        `${Chaser}${row?.id}/`,
        payload
      );

      if (response?.status === 200 || response?.status === 201) {
        commonToast("success", "Changes saved successfully!");
        // Refresh the data
        setDate1("");
        setDate2("");
        setDate3("");
        setEscalationDate("");
        loadData();
      }
    } catch (error) {
      console.error("Error saving changes:", error);
      commonToast("error", "Failed to save changes");
    }

    // After saving, reset the modification flags for this row
    setModifiedRows(prev => {
      const newState = { ...prev };
      delete newState[row.id];
      return newState;
    });
  };

  const UserAuthorisation = userData?.user_permissions?.permissions_list['Chaser'];

  return (
    <>
      <style>
        {`
          /* Override MUI DatePicker calendar colors to blue */
          .MuiPickersDay-root.Mui-selected {
            background-color: #1672DE !important;
            color: white !important;
          }
          .MuiPickersDay-root.Mui-selected:hover {
            background-color: #1565c0 !important;
          }
          .MuiPickersDay-root:hover {
            background-color: rgba(22, 114, 222, 0.1) !important;
          }
          .MuiPickersCalendarHeader-root .MuiIconButton-root {
            color: #1672DE !important;
          }
          .MuiPickersCalendarHeader-root .MuiIconButton-root:hover {
            background-color: rgba(22, 114, 222, 0.1) !important;
          }
          .MuiPickersMonth-root.Mui-selected {
            background-color: #1672DE !important;
            color: white !important;
          }
          .MuiPickersYear-root.Mui-selected {
            background-color: #1672DE !important;
            color: white !important;
          }
          .MuiPickersDay-dayWithMargin {
            color: #1672DE !important;
          }
          .MuiPickersDay-dayWithMargin.Mui-selected {
            background-color: #1672DE !important;
            color: white !important;
          }
        `}
      </style>
    <div style={Container}>
      {UserAuthorisation?.["View"] === "Y" ? (
        <>
        <Box
                sx={{
            "& .MuiTab-root": {
              "&.Mui-selected": {
                backgroundColor: "#1672DE !important",
                color: "white !important",
              },
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
            {/* Filter Sidebar */}
            <CommonFilterSidebar
              isOpen={filterSidebarOpen}
              filterConfigs={[
                {
                  type: "textInput",
                  label: "Transaction Id",
                  value: searchFieldsPrams?.Bank_Transaction_Id || "",
                  onChange: (value) => handleChaserFieldsInputChange("Bank_Transaction_Id", value),
                  onKeyUp: handleEnter,
                },
                {
                  type: "textInput",
                  label: "Policy No",
                  value: searchFieldsPrams?.Policy_No || "",
                  onChange: (value) => handleChaserFieldsInputChange("Policy_No", value),
                  onKeyUp: handleEnter,
                },
                {
                  type: "custom",
                  content: (
                    <>
                      <Typography
                sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#000",
                          marginBottom: "12px",
                        }}
                      >
                        Broker Branch
                      </Typography>
                  <CommonSelect
                    placeholder="Select Broker Branch"
                    value={searchFieldsPrams?.Broker_Branch ?? ""}
                    handleChange={(event, value, reason) =>
                          handleFilterDropdown("Broker_Branch", value, reason)
                    }
                    options={brokerList || []}
                  />
                    </>
                  ),
                },
                {
                  type: "custom",
                  content: (
                    <>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#000",
                          marginBottom: "12px",
                        }}
                      >
                        Handler Name
                      </Typography>
                  <CommonSelect
                    placeholder="Select Handler Name"
                    value={searchFieldsPrams?.Handler_Name ?? ""}
                    handleChange={(event, value, reason) =>
                          handleFilterDropdown("Handler_Name", value, reason)
                    }
                    options={userData?.role === "CC Processor" ? [`${userData?.user_name}`] : users?.map((option) => option?.user_name) || []}
                  />
                    </>
                  ),
                },
                {
                  type: "dateRange",
                  label: "Allocated Date",
                  startDate: fromDateValue,
                  setStartDate: setFromDateValue,
                  endDate: toDateValue,
                  setEndDate: setToDateValue,
                  maxDate: new Date(),
                  onKeyUp: handleEnter,
                },
              ]}
              onApplyFilters={handleSearchChaserList}
              onClearFilters={() => handleClearSearchList()}
              isLoading={pageState?.isLoading}
              isFilterDisabled={isFilterBtnDisable()}
            />

            {/* Main Content Area */}
            <Box className="main-content-area" sx={{ minWidth: 0, overflow: "hidden" }}>
              {/* Top Row: Heading Section and Summary Table side by side */}
              <Box sx={{ display: "flex", gap: "20px", mb: 2, alignItems: "flex-start", minWidth: 0 }}>
                {/* Left: Heading Section */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", minWidth: "300px" }}>
                  <Typography
                    variant="h5"
                    className="page-heading"
                sx={{
                      color: "#1672DE",
                      fontSize: "24px",
                      fontWeight: "600",
                    }}
                  >
                    Query Tracker
                  </Typography>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                      minHeight: "36px",
                      width: "fit-content",
                      "& .MuiTabs-indicator": {
                        display: "none",
                      },
                      "& .MuiTabs-flexContainer": {
                        width: "fit-content",
                      },
                    }}
                    aria-label="chaser tabs"
                  >
                    <Tab
                      label="Allocated"
                      sx={{
                        borderRight: "1px solid #e0e0e0",
                        backgroundColor: tabValue === 0 ? "#1672DE !important" : "transparent !important",
                        color: tabValue === 0 ? "white !important" : "#666 !important",
                        borderRadius: "6px 0 0 6px",
                        minHeight: "36px",
                        minWidth: "100px",
                        maxWidth: "100px",
                        padding: "6px 16px",
                        textTransform: "none",
                        fontWeight: tabValue === 0 ? "600" : "400",
                        "&:hover": {
                          backgroundColor: tabValue === 0 ? "#0d5ba3 !important" : "rgba(22, 114, 222, 0.05) !important",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#1672DE !important",
                          color: "white !important",
                        },
                      }}
                    />
                    <Tab
                      label="Over Due"
                      sx={{
                        borderRight: "1px solid #e0e0e0",
                        backgroundColor: tabValue === 1 ? "#1672DE !important" : "transparent !important",
                        color: tabValue === 1 ? "white !important" : "#666 !important",
                        minHeight: "36px",
                        minWidth: "100px",
                        maxWidth: "100px",
                        padding: "6px 16px",
                        textTransform: "none",
                        fontWeight: tabValue === 1 ? "600" : "400",
                        "&:hover": {
                          backgroundColor: tabValue === 1 ? "#0d5ba3 !important" : "rgba(22, 114, 222, 0.05) !important",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#1672DE !important",
                          color: "white !important",
                        },
                      }}
                    />
                    <Tab
                      label="Query"
                      sx={{
                        backgroundColor: tabValue === 2 ? "#1672DE !important" : "transparent !important",
                        color: tabValue === 2 ? "white !important" : "#666 !important",
                        borderRadius: "0 6px 6px 0",
                        minHeight: "36px",
                        minWidth: "100px",
                        maxWidth: "100px",
                        padding: "6px 16px",
                        textTransform: "none",
                        fontWeight: tabValue === 2 ? "600" : "400",
                        "&:hover": {
                          backgroundColor: tabValue === 2 ? "#0d5ba3 !important" : "rgba(22, 114, 222, 0.05) !important",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#1672DE !important",
                          color: "white !important",
                        },
                      }}
                    />
                  </Tabs>
                </Box>

                {/* Right: Summary Table - 2 rows with 1 heading col and 5 data cols */}
                <Box sx={{ flex: 1, display: "flex", justifyContent: "center", minWidth: 0 }}>
                  <Box sx={{ 
                    p: 0, 
                    backgroundColor: "#ffffff", 
                    borderRadius: "12px", 
                    width: "100%",
                    maxWidth: "100%",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                    overflow: "hidden",
                  }}>
                    <Table aria-label="summary table" sx={{ 
                      width: "100%", 
                      borderCollapse: "collapse",
                      "& .MuiTableCell-root": {
                        border: "none",
                      }
                    }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px",
                            "&:first-of-type": {
                              borderTopLeftRadius: "12px",
                            },
                          }} align="center">
                            Total
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px"
                          }} align="center">
                            Query Status
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px"
                          }} align="center">
                            Premium Due
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px"
                          }} align="center">
                            1st Follow Up
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px"
                          }} align="center">
                            2nd Follow Up
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px",
                            "&:last-of-type": {
                              borderTopRightRadius: "12px",
                            }
                          }} align="center">
                            Escalation
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "600"
                          }} align="center">
                            Value
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {historyData?.query_status ?? 0}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {numberFormatter(
                              typeof historyData?.premium_due_amount === "number" && !isNaN(historyData.premium_due_amount)
                                ? historyData.premium_due_amount
                                : 0
                            )}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {historyData?.in_date2 ?? 0}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {historyData?.in_date3 ?? 0}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 10px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {historyData?.in_escalation ?? 0}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Box>

                {/* Filter Toggle Button */}
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <IconButton
                    onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                    className="filter-toggle-button"
                  >
                    <FilterListIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* DataGrid - Full width below */}
              <Box
                sx={{
                  flex: 1,
            display: "flex",
            flexDirection: "column",
                  minHeight: 0,
              position: "relative",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                  overflow: "visible",
                  transition: "all 0.3s ease",
                  border: "1px solid #e8eaf0",
                  paddingBottom: "10px",
                  "&:hover": {
                    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                  },
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={pageState?.isLoading}
              rows={pageState?.data ?? []}
              columns={columns}
              rowCount={pageState?.total}
              keepNonExistentRowsSelected
              disableSelectionOnClick
              pagination
              paginationMode="server"
              getRowId={(row) => row?.id}
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              rowsPerPageOptions={[10, 25, 50, 100]}
              onPageSizeChange={(newPageSize) => {
                setPageState((old) => {
                  setPaginationCount(
                    getPaginationCount(pageState?.total, newPageSize)
                  );
                  return { ...old, pageSize: newPageSize, page: 1 };
                });
                setShouldLoadData(true);
              }}
              sx={{
                    border: "none",
                    flex: 1,
                    minHeight: 0,
                    "& .MuiDataGrid-root": {
                      border: "none",
                      height: "100%",
                    },
                    "& .MuiDataGrid-main": {
                      height: "100%",
                      "&::-webkit-scrollbar": {
                        width: "8px",
                        height: "8px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#1672DE",
                        borderRadius: "10px",
                        "&:hover": {
                          background: "#0d5ba3",
                        },
                      },
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f8f9fa",
                      borderBottom: "2px solid #e0e0e0",
                      minHeight: "52px !important",
                      maxHeight: "52px !important",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      backgroundColor: "transparent",
                      fontWeight: "600",
                      color: "#1672DE",
                      fontSize: "14px",
                      padding: "12px 16px",
                      borderBottom: "none",
                      overflow: "visible",
                      "&:focus": {
                        outline: "none",
                      },
                      "&:focus-within": {
                        outline: "none",
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        fontWeight: "600",
                        fontSize: "14px",
                        overflow: "visible",
                        textOverflow: "clip",
                        whiteSpace: "normal",
                        lineHeight: "1.4",
                        width: "100%",
                      },
                      "& .MuiDataGrid-sortIcon": {
                        color: "#1672DE",
                      },
                      "& .MuiDataGrid-menuIcon": {
                        color: "#1672DE",
                      },
                    },
                    "& .MuiDataGrid-row": {
                      transition: "all 0.2s ease",
                      borderBottom: "1px solid #f0f0f0",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.04)",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "rgba(22, 114, 222, 0.08)",
                        "&:hover": {
                          backgroundColor: "rgba(22, 114, 222, 0.12)",
                        },
                      },
                      "&:nth-of-type(even)": {
                        backgroundColor: "#fafafa",
                        "&:hover": {
                          backgroundColor: "rgba(22, 114, 222, 0.04)",
                        },
                      },
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "1px solid #f0f0f0",
                      padding: "12px 16px",
                      fontSize: "13px",
                      color: "#333",
                      display: "flex",
                      alignItems: "center",
                      "&:focus": {
                        outline: "none",
                      },
                      "&:focus-within": {
                        outline: "none",
                      },
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      "&::-webkit-scrollbar": {
                        width: "8px",
                        height: "8px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#1672DE",
                        borderRadius: "10px",
                        "&:hover": {
                          background: "#0d5ba3",
                        },
                      },
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "2px solid #e0e0e0",
                      backgroundColor: "#f8f9fa",
                      minHeight: "48px",
                      maxHeight: "48px",
                      paddingBottom: "8px",
                      paddingTop: "8px",
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      position: "relative",
                      zIndex: 1,
                    },
                    "& .MuiDataGrid-loadingOverlay": {
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                },
              }}
            />
            <Stack
                  sx={{
                position: "absolute",
                    bottom: "16px",
                    right: "20px",
                    zIndex: 10,
                    backgroundColor: "#f8f9fa",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
                setShouldLoadData={setShouldLoadData}
              />
            </Stack>
              </Box>
            </Box>
          </Box>
        </Box>

        <Dialog open={openCommentsDialog} onClose={handleCloseDialogs}>
          <DialogTitle>
            Comment
          </DialogTitle>
          <DialogContent sx={{ overflow: "hidden", textAlign: "center" }}>
            <TextareaAutosize
              minRows={5}
              value={dialogCommentsValue}
              onChange={handleDialogInputChange}
              className=""
              style={{ width: "350px", minWidth: "350px" }}
              // disabled={currentCommentsIndex!=selectedRowIndex}
            />
            {oldConcatenatedComment && (
              <div
                style={{
                  textWrap: "wrap",
                  backgroundColor: "rgb(175, 171, 170)",
                  marginTop: "10px",
                  padding: "20px",
                  borderRadius: "5px",
                  whiteSpace: "pre-wrap",
                  textAlign: "left",
                  maxHeight:"300px",
                  overflowY:"scroll",
                  maxWidth:"400px"
                }}
              >
                {oldConcatenatedComment}
              </div>
            )}
          </DialogContent>
          
          <DialogActions>
            <CommonButton
              text="Cancel"
              handleClick={handleCloseDialogs}
              sx={{
                backgroundColor: "#ffff",
                color: "#000000",
                border: "1px solid #BCBDBF",
              }}
            />
            <CommonButton
              text="Save"
              handleClick={handleSaveComments}
              disabled={!dialogCommentsValue}
              sx={primaryButtonStyle}
              hoverColor={primaryButtonHoverColor}
            />
          </DialogActions>
        </Dialog>

        {/* Follow up Audit Trail model */}
        {isAuditOpen && (
          <Dialog 
            open={isAuditOpen} 
            onClose={handleCloseDialogs} 
            maxWidth='lg'
            fullWidth
            sx={{ width: "100%", height: "80vh", marginTop: "5%" }}
          >
            <DialogTitle sx={{fontSize: "1.5rem"}}>Audit Trail</DialogTitle>
            <DialogContent sx={{ overflow: "hidden", height: "70vh" }}>
              <Grid container spacing={2} mt={2} paddingLeft={2}>
                <Grid item xs={12}>
                  <div style={{height: "50vh", overflowY: "auto"}}>
                    <table style={{width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed Field</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Value</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>New Value</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed By</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Last Edit Time</th>
                          {/* <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Timestamp</th> */}
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRow && currentRow?.followup_audit_data?.map((audit, index) => (
                        <tr key={index}>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.field_name}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.old_value}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.new_value}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.changed_by}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.current_edit_datetime}</td>
                            {/* <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.time_diff}</td> */}
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.event_type === 'add' ? 'Added Follow Up' : audit.event_type}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <CommonButton
                text="Cancel"
                handleClick={handleCloseDialogs}
                sx={{
                  backgroundColor: "#ffff",
                  color: "#000000",
                  border: "1px solid #BCBDBF",
                }}
              />
            </DialogActions>
          </Dialog>
        )}
        </>
      ) : <div style={{paddingTop: "25%", textAlign: "center"}}>You are not authorized to view this page.</div>}
    </div>
    </>
  );
}
